/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2021-09-02 16:49:07
 * @modify date 2021-09-02 16:49:07
 * @desc 留资
 */
import { computed } from 'mobx';
import { EnumAPI } from '../../apis';
import { AjaxBasics } from '../../helpers';
import { BaseModel, BasesController } from '../bases';
export class RetaincapitalController<T = any> extends BasesController<T> {
    constructor() {
        super();
        this.reset({
            dataKey: 'id',
            infinite: true,
            pagination: EnumAPI.content_isg_retaincapital_list,
            // details: EnumAPI.usersvr_bizNews_details,
            paginationParams: {
                currentKey: 'curPageNo',
                pageSizeKey: 'pageSize',
                filterKey: 'search',
                response: {
                    dataSource: 'recordList',
                    total: 'recordCount',
                }
            },
        })
    }

    /**
     * 值存储
     * @memberof RetaincapitalController
     */
    Model = new BaseModel({ type: 'object' })
    StorageModel = new BaseModel({ type: 'object', storageKey: 'retaincapital' })

    get StatusType() {
        return [
            { label: '待处理', value: '0' },
            { label: '已处理', value: '1' }
        ]
    }

    @computed
    get isNoTip() {
        return this.StorageModel.get('notip', false)
    }

    /**
     * 导出留资
     */
    async onExport(body) {
        try {
            await AjaxBasics.request({ ...EnumAPI.content_isg_retaincapital_export, body })
        } catch (error) { }
    }

    /**
     * 变更留资状态
     */
    async onUpdateStatus(body) {
        // try {
        await AjaxBasics.request({ ...EnumAPI.content_isg_retaincapital_update_status, queryParams: body })
        // } catch (error) { }
    }

    /**
     * 提交留资
     */
    async onSaveData(body) {
        // try {
        await AjaxBasics.request({ ...EnumAPI.content_isg_retaincapital_save, body })
        // } catch (error) { }
    }
}
